import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import useAI from "../../context/AIContext";
import PantallaContext from "../../context/PantallaContext";

const AskAI = ({ opciones, datos }) => {
  const openChat = useAI(state => state.openChat)

  const p = useContext(PantallaContext)

  const conf = p.refState.configuraciones.find(c => c.opciones.id_a === opciones.id_a)?.cabeceras.find(cab => cab.tipo.id === 23)
  if (!conf) return <></>
  const handleClick = () => {
    openChat(opciones.AI, { ...p.qsBody, ...datos }, conf)
  };

  return (
    <div
      className={
        opciones.titulo
          ? "flex_acciones_vista_imprimir"
          : "flex_acciones_vista_alt_imprimir"
      }
      style={{ position: "fixed" }}
    >
      <div
        onClick={handleClick}
        style={{ cursor: "pointer" }}
        title="Abrir chat con IA"
        aria-label="Abrir chat con IA"
      >
        <FontAwesomeIcon icon={faComments} />
      </div>
    </div>
  );
};

export default AskAI;
